import { useLocation } from 'wouter'
import { useCasquette } from '../contexts/casquette'
import { MVP } from '../mvp'
import { ROUTES } from '../routes'
import useDossierExposant from '../hooks/useDossierExposant'
import { avecAlpha } from '../lib/couleurs'
import { texteRappel } from '../pages/account/dossier/dossierUi'

const ORANGE = 'rgb(var(--c-primary))'
const VERT = 'rgb(var(--c-green))'

/**
 * Rappel « Dossier exposant à compléter » (prototype v7.5 `RappelBulle`, D6).
 * Rendu DANS la bulle RINA de toutes les pages, juste apres le message — et,
 * quand la bulle d'une page a ete refermee, SEUL sous la pastille renard (S73,
 * Enzo : « il ne faut pas qu'il puisse le rater »).
 *
 * Trois conditions : casquette producteur, niveau INCOMPLET, pas deja sur la
 * page du dossier. La carte RINA peut elle-meme etre un bouton : le rappel est
 * donc un `span role="button"` (pas de bouton imbrique), qui arrete la
 * propagation et se pilote au clavier (Entree, Espace).
 */
function RappelDossierBulle({ seul = false }) {
  const [location, setLocation] = useLocation()
  const { hubMode } = useCasquette()
  const actif = MVP.DOSSIER_EXPOSANT && hubMode === 'producer'
  const etat = useDossierExposant({ enabled: actif })
  if (!actif || !etat || etat.niveau !== 'INCOMPLET' || location === ROUTES.compte.dossier) return null

  const aller = (e) => {
    e.stopPropagation()
    e.preventDefault()
    setLocation(ROUTES.compte.dossier)
  }
  return (
    <span
      role="button"
      tabIndex={0}
      onClick={aller}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') aller(e) }}
      className={`relative flex items-center gap-[9px] rounded-[14px] cursor-pointer text-left ${seul ? 'mb-3' : 'mt-[9px]'}`}
      style={{ padding: '9px 10px', background: avecAlpha(ORANGE, 0.16), border: `1px solid ${avecAlpha(ORANGE, 0.45)}` }}
    >
      <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: ORANGE, animation: 'pulse 2s ease-in-out infinite' }} />
      <span className="flex-1 min-w-0">
        <span className="block text-[12.5px] font-extrabold leading-tight" style={{ color: VERT }}>📋 Dossier exposant à compléter</span>
        <span className="block text-[11.5px] font-medium leading-snug mt-px" style={{ color: 'rgba(7,62,61,0.72)' }}>{texteRappel(etat)}</span>
      </span>
      <span className="text-[11.5px] font-extrabold rounded-full flex-shrink-0" style={{ color: VERT, background: ORANGE, padding: '6px 10px' }}>
        Compléter ›
      </span>
    </span>
  )
}

export default RappelDossierBulle
